import React from 'react';
import PropTypes from 'prop-types';

/**
 * 加载动画组件
 * 现在只剩一个地方用了，就是 CandidateInfo 的 upload 进度条
 */
class LoadingIndicator extends React.Component {
  render() {
    const { loading, text, className, percent } = this.props;

    if (!loading) {
      return null;
    }

    return (
      <div className={`loading-indicator--upload ${className}`}>
        <div className="loading-indicator--upload__progress">
          <div
            className="loading-indicator--upload__progress__percent"
            // eslint-disable-next-line react/forbid-dom-props
            style={{ width: `${percent}%` }}
          />
        </div>
        <span className="loading-indicator__text">{text}</span>
      </div>
    );
  }
}

LoadingIndicator.defaultProps = {
  className: '',
  loading: true,
  percent: 0,
  text: '',
};

LoadingIndicator.propTypes = {
  className: PropTypes.string,
  /**
   * 是否处于加载状态
   */
  loading: PropTypes.bool.isRequred,
  /**
   * 如果类型是upload，则可以指定进度
   */
  percent: PropTypes.number,
  /**
   * 文字说明
   */
  text: PropTypes.string,
};

export default LoadingIndicator;
